/** @jsx jsx */
import React from 'react';
import { Box, jsx } from 'theme-ui';

import { appendZeroOnSlideCount } from '../../assets/js/utils';

const RenderSlideCount = ({ currentSlide, total }) => {
  return (
    <Box sx={sliderCount}>
      <span sx={sliderCount.current}>
        <>{appendZeroOnSlideCount(currentSlide + 1)}</>
      </span>
      <span sx={sliderCount.separator}> /</span>
      <span sx={sliderCount.total}>{appendZeroOnSlideCount(total)}</span>
    </Box>
  );
};

const sliderCount = {
  fontFamily: 'heading',
  fontStyle: 'italic',
  fontWeight: 'light',
  width: 120,
  textAlign: 'center',
  variant: 'styles.textGradient',
  whiteSpace: 'nowrap',
  current: {
    fontSize: 7,
  },
  separator: {
    fontSize: 45,
  },
  total: {
    fontSize: 6,
  },
};

export default RenderSlideCount;
